<template>
  <svg
    class="arrow"
    xmlns="http://www.w3.org/2000/svg"
    width="9.061"
    height="16.061"
    viewBox="0 0 9.061 16.061"
  >
    <g
      id="Group_1810"
      data-name="Group 1810"
      transform="translate(-626.97 1353.03)"
    >
      <line
        id="Line_8"
        data-name="Line 8"
        y1="8"
        x2="8"
        transform="translate(627.5 -1345.5)"
        fill="none"
        stroke="#666"
        stroke-width="1.5"
      />
      <line
        id="Line_9"
        data-name="Line 9"
        x2="8"
        y2="8"
        transform="translate(627.5 -1352.5)"
        fill="none"
        stroke="#666"
        stroke-width="1.5"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'SearchIcon'
}
</script>

<style scoped lang="scss">
.arrow{
  margin-top: 3px;
}
</style>
